import { render } from "./BooleanField.vue?vue&type=template&id=0314fd18"
import script from "./BooleanField.vue?vue&type=script&lang=js"
export * from "./BooleanField.vue?vue&type=script&lang=js"
script.render = render

export default script